import { createSlice } from "@reduxjs/toolkit";

export const roominvitationSlice = createSlice({
    name: "roominvitation",
    initialState: {
        id: null,
        uid: null,
        channelId: null,
        isValid: null
    },
    reducers: {
        unsetRoominvitation: (state) => {
            state.id = null;
            state.uid = null;
            state.channelId = null;
            state.isValid = null;
        },
        setRoominvitation: (state, action) => {
            state.id = action.payload.id
            state.uid = action.payload.uid
            state.channelId = action.payload.channelId
            state.isValid = action.payload.isValid
        },
    },
});

export const { unsetRoominvitation, setRoominvitation } = roominvitationSlice.actions;

export const selectInviteId = (state) => state.roominvitation.id;
export const selectInviteUid = (state) => state.roominvitation.uid;
export const selectInviteChannelId = (state) => state.roominvitation.channelId;
export const selectInviteIsValid = (state) => state.roominvitation.isValid;

export default roominvitationSlice.reducer;